import React from "react";
import { MdArrowForwardIos } from "react-icons/md";

const CheckDemo = () => {
  return (
    <div className=" text-primary center cursor-pointer">
      <div>Check demo</div>
      <div>
        <MdArrowForwardIos />
      </div>
    </div>
  );
};

export default CheckDemo;
